export class RekbotSettingsOpenHours {
    public id: number|null;
    public rekbot_id: number|null;
    public day: number;
    public open: number;
    public open_time: string;
    public close_time: string;

    constructor(
        id: number|null, 
        rekbot_id: number|null, 
        day: number, 
        open: number, 
        open_time: string,
        close_time: string
        ) {
            
        this.id = id;
        this.rekbot_id = rekbot_id;
        this.day = day;
        this.open = open;
        this.open_time = open_time; 
        this.close_time = close_time; 
    }

    static empty() {
        return [
      {
        "id": null,
        "rekbot_id": null,
        "day": 1,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 2,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 3,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 4,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 5,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 6,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 7,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      }]
    }
}